import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { ButtonGroup } from '@/core/ButtonGroup.molecule';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { ButtonItem } from '@/core/ButtonGroup.molecule';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface ButtonGroupIF extends ValidatingFormComponent<string> {
  component: 'ButtonGroupFormComponent';
  buttonItems: ButtonItem[];
}

/**
 * A wrapper around the `ButtonGroup` component for use with `FormBuilder`
 */
export const ButtonGroupFormComponent = (props: ButtonGroupIF) => {
  const {
    name,
    testId = 'buttonGroup',
    label,
    buttonItems,
    validation,
    extendValidation,
    wrapperClassNames,
    extraClassNames,
    required,
    tooltip,
    tooltipPlacement = 'top',
    onTooltipClick,
  } = props;

  const defaultValidation = (value: string) => (required ? !value : false);

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <FormFieldWrapper
      fieldXstyle={[props.xstyle, props.fieldXstyle]}
      labelXstyle={props.labelXstyle}
      wrapperXstyle={[styles.wrapper, props.wrapperXstyle]}
      testId={testId}
      label={label}
      tooltip={tooltip}
      tooltipPlacement={tooltipPlacement}
      wrapperClassNames={wrapperClassNames}
      extraClassNames={extraClassNames}
      onTooltipClick={onTooltipClick}>
      <Field<string> name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { value, name, onChange } = getFormFieldProps(formState, input, meta, props);

          return (
            <ButtonGroup
              buttonItems={_.map(buttonItems, (item, i) => ({ ...item, key: `${item.id || item.label}-${i}` }))}
              name={name}
              value={value}
              onChange={onChange}
              testId={`${testId}Field`}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};

const styles = stylex.create({ wrapper: { marginLeft: '.125rem' } });
